import { Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CurrencyFormatter } from "../utils/CurrencyFormatter";
export default function AttendantSalesDetails({
  open,
  attendant,
  handleClose,
  data,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title attendant-performance-heading">
          Attendant's Performance Report: {attendant?.name}
        </DialogTitle>
        <DialogContent>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Date Added:
            </span>
            <span className="attendant-performance-item-value checked">
              {attendant?.added_at || data?.added_at}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              No. of Transactions:
            </span>
            <span className="attendant-performance-item-value checked">
              {data?.transactions}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Total Sales:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.total_sales)}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Average Sales:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.total_sales / data?.transactions)}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Retail Sales:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.retail_sales)}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Wholesale Sales:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.wholesale_sales)}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Discounted Sales:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.discounted_sales)}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Cash Sales:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.cash)}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Mobile Money:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.momo)}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Bank Transfer:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.bank)}
            </span>
          </div>
          <div className="attendant-performance-item">
            <span className="attendant-performance-item-key unchecked">
              Credit:
            </span>
            <span className="attendant-performance-item-value checked">
              {CurrencyFormatter(data?.credit)}
            </span>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn" onClick={handleClose}>
            <Close />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
